<template>
	<div id="strategy-policy">
		{{msg}}
	</div> 	
</template>

<script>
	export default {
	  name: 'strategy-policy',
	  data(){
	  	return{
	  		msg:"策略与政策"
	  	}
	  },
	}
</script>

<style>
</style>
